import React, { Component, useEffect } from "react";
import $ from "jquery";
import axios from "axios";
import { instance } from "./Axios";
import { navigate } from "gatsby";
import { isLoggedIn, getAuthToken } from "./Auth";
import FormChangePassword from "../components/AccountChangePassword";
import { headerConfigWithAuthorize } from "./Header";

class ChangePassword extends React.Component {
  state = {
    old_password: "",
    new_password: "",
    lang: "",
    fields: "",
    loadings: [],
    confirmLoading: false,
    submited: false,
  };

  showLoading() {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = true;

      return {
        loadings: newLoadings,
      };
    });
  }

  hideLoading() {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = false;

      return {
        loadings: newLoadings,
      };
    });
  }

  handleUpdate(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleSubmit(params) {
    try {
      let self = this;
      self.showLoading();
      self.setState({ submited: false });
      let token = getAuthToken();
      let header = headerConfigWithAuthorize(token);
      $(".action_status").text("");
      const bodyFormData = new FormData();
      bodyFormData.append("old_password", params.old_password);
      bodyFormData.append("new_password", params.new_password);
      bodyFormData.append("lang", self.props.langKey);

      (async () => {
        await axios
          .post(
            `${process.env.GATSBY_API_URL}/api/guest/change-password`,
            bodyFormData,
            header
          )
          .then(function (response) {
            self.hideLoading();
            if (response.data.status_code == 200500) {
              self.setState({ submited: true });
              $(".action_status")
                .addClass("status_success")
                .text(response.data.message);
            } else {
              $(".action_status")
                .addClass("status_error")
                .text(response.data.message);
            }
          })
          .catch(function (error) {
            if (error.response) {
              $(".action_status")
                .addClass("status_error")
                .text(error.response.data.message);
              self.hideLoading();
            } else if (error.request) {
              console.log(error.request);
              self.hideLoading();
            } else {
              console.log("Error", error.message);
              self.hideLoading();
            }
          });
      })();
    } catch (error) {
      console.log(error);
      this.hideLoading();
    }
  }

  render() {
    return (
      <FormChangePassword
        stateProp={this.state}
        props={this.props}
        handleSubmit={(e) => this.handleSubmit(e)}
      />
    );
  }
}

export default ChangePassword;
